import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Table, Avatar, Row } from 'antd'
import '../../css/customer.scss'
import { fetchCustomers } from '../../store/action/customer.action'
import TestClinicTag from '../common/testclinic.tag'
import { loginAsCustomer } from '../../store/action/profile.action'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

const UserTable = (props) => {
  var history = useHistory()

  useEffect(() => {
    fetchCustomersList(
      { current: 1, pageSize: 20 },
      null,
      { order: 'ascend', field: 'name' }
    )
  }, [props.company, props.companyid])

  var fetchCustomersList = (pagination, _filters, sorter) => {
    props.fetchCustomers({
      companyid: props.company ? props.company?._id : props.companyid,
      pagination,
      searchText: props.searchText,
      sorter: sorter?.order ? { field: sorter.field, order: sorter.order } : undefined,
    })
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  var dataSource = formatdata(props.customers)
  var pagination = {
    ...props.pagination,
    showSizeChanger: true,
  }

  var renderName = (name, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={obj?.logo}>{name ? name[0]?.toUpperCase() : ''}</Avatar>
        <span>{_.upperFirst(name)}</span>
        <TestClinicTag isTest={obj?.istestclinic} />
      </Row>
    )
  }

  var handleRowClick = (record) => {
    props.loginAsCustomer(record)
    history.push('/surgeons')
  }

  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  var handleLoginAs = (e, row) => {
    e.stopPropagation()
    history.push('/customers/edit/' + row._id)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      sorter: true,
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend'],
      render: (name, obj) => renderName(name, obj),
    },
    {
      title: 'Contact - Name',
      dataIndex: 'contact',
      render: (contact, obj) => contact?.name,
    },
    {
      title: 'Contact - Email',
      dataIndex: 'contact',
      render: (contact, obj) => contact?.email,
    },
    {
      title: 'PATIENTS',
      dataIndex: 'patients',
    },
    {
      title: 'Contact - Phone',
      dataIndex: 'contact',
      render: (contact, obj) =>
        formatPhoneNumberIntl(contact?.phone ? contact?.phone : ''),
    },
    {
      title: 'City',
      dataIndex: 'address',
      render: (address, obj) => address?.city,
    },
    {
      title: 'State',
      dataIndex: 'address',
      render: (address, obj) => address?.state,
    },
    {
      title: 'ZIp',
      dataIndex: 'address',
      render: (address, obj) => address?.zip,
    },
    {
      title: 'ACTION',
      align: 'center',
      width: '200px',
      render: (row, obj) => (
        <Link onClick={(e) => handleLoginAs(e, row)}>Edit</Link>
      ),
    },
  ]

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={dataSource}
        loading={props.isLoading}
        pagination={pagination}
        onChange={fetchCustomersList}
        bordered={false}
        onRow={handleRow}
        showSorterTooltip={{ title: 'Click to sort' }}
      />
    </>
  )
}

UserTable.propTypes = {
  fetchSurgeon: PropTypes.func.isRequired,
  surgeons: PropTypes.array,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  pagination: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedSurgeons: PropTypes.array,
  active: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    customers: state.customer.customers,
    searchText: state.customer.searchText,
    pagination: state.customer.pagination,
    isLoading: state.customer.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomers: (params) => dispatch(fetchCustomers(params)),
    loginAsCustomer: (customer) => dispatch(loginAsCustomer(customer)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserTable)
